module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "fullToolbar"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("recent_actors")]), _vm._v("\n    " + _vm._s(_vm.$t('projects')) + "\n    "), _c('v-btn', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "fab": "",
      "light": "",
      "small": "",
      "color": "primary",
      "title": "הוסף חדש"
    },
    nativeOn: {
      "click": function($event) {
        _vm.isNew = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "width": "120px",
      "height": "30px"
    },
    attrs: {
      "light": "",
      "small": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("list")]), _vm._v("הצג רשימה\n    ")], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "width": "120px",
      "height": "30px"
    },
    attrs: {
      "light": "",
      "small": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("place")]), _vm._v("הצג מפה\n    ")], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px",
      "text-align": "center!important"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a5ea638"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 862
// module chunks = 2